module.exports = __webpack_public_path__ + "img/video-muted.1431c2ba.svg";